import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinpune() {



const cardData = {
  keyword: " Force Urbania On Rent in Pune ",

headingDescription: "Velocity Cab offers Force Urbania on rent in Pune, providing a rugged, comfortable, and spacious SUV option ideal for off‑road adventures, group outings, family trips, and long‑distance travel. Our well‑maintained Force Urbania vehicles are powerful, air‑conditioned, and equipped to handle Pune’s city roads as well as nearby hill routes and rural terrain. Whether you need an hourly rental, full‑day service, airport transfers, or outstation journeys, we offer flexible booking options with transparent pricing and no hidden charges. With professional drivers, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for renting Force Urbania in Pune.",

topPlaces: [
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a historic hill fortress located near Pune and is ideal for visitors who enjoy adventure and panoramic views. Travelers renting a Force Urbania in Pune can enjoy a comfortable drive through winding roads to the fort, explore its ancient gates and bastions, and trek along scenic trails. The summit offers breathtaking views of the Sahyadri mountains and is a great spot for photography and picnics. Local vendors also serve traditional Maharashtrian snacks like pithla bhakri, adding to the cultural experience."
  },
  {
    title: "Lavasa City",
    description: "Lavasa City is a hill‑station‑style planned town near Pune known for its picturesque lakes, lush green hills, and European‑inspired architecture. Visitors using a Force Urbania rental can take a scenic drive from Pune to Lavasa, enjoy boat rides on the lake, explore waterfront promenades, and capture stunning landscape views. The rugged and powerful vehicle makes the journey smooth and enjoyable, especially on hilly terrain."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a popular picnic and camping destination near Pune with serene water views and surrounding hills. Travelers with a Force Urbania on rent can comfortably reach the lake, set up picnics or camping gear, and enjoy outdoor activities like kayaking, photography, and bonfires. The tranquil environment and scenic sunset views make it an ideal getaway from the city hustle."
  },
  {
    title: "Mulshi Dam",
    description: "Mulshi Dam is a beautiful reservoir surrounded by lush green hills and valleys. A Force Urbania rental allows travelers to enjoy a relaxed drive from Pune, explore the dam area, and take in spectacular views of the water and greenery. The location is perfect for picnics, nature walks, and capturing breathtaking photos of the landscape."
  },
  {
    title: "Rajmachi Fort",
    description: "Rajmachi Fort is a historic hill fort located near Pune, offering a blend of adventure, history, and natural beauty. Travelers renting a Force Urbania can head to Rajmachi to trek historic trails, explore ancient ruins, and enjoy sweeping views of the Sahyadri range. The rugged SUV makes off‑road sections and uphill paths more manageable, enhancing the overall experience."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a serene destination near Pune famed for its paragliding, lakes, and quiet countryside vibes. Visitors using a Force Urbania on rent can drive through scenic routes to the paragliding spots, enjoy aerial views of the landscape, and relax by the lakes. The powerful SUV is perfect for navigating rural roads and reaching hilltop take‑off points for paragliding activities."
  },
  {
    title: "Bhaja Caves",
    description: "Bhaja Caves are ancient rock‑cut Buddhist caves near Pune, known for their intricate carvings and historical significance. Travelers renting a Force Urbania can explore these caves, which are set amidst lush greenery and hilly terrain. The rugged vehicle ensures a smooth journey on the uneven roads leading to this heritage site."
  },
  {
    title: "Khandala Viewpoint",
    description: "Khandala Viewpoint offers breathtaking views of the Western Ghats and is a favorite spot for nature lovers and photographers. Travelers using a Force Urbania rental can enjoy a picturesque drive through winding roads and stop at the viewpoint to capture panoramic landscapes, especially during sunrise or sunset. The robust SUV makes the hilly drive comfortable and enjoyable."
  },
  {
    title: "Tamhini Ghat",
    description: "Tamhini Ghat is a scenic mountain pass near Pune known for its waterfalls, lush greenery, and winding roads. Visitors renting a Force Urbania can take advantage of the powerful SUV to navigate the ghat’s curves and explore beautiful spots along the way. The region is especially stunning during the monsoon season when the waterfalls and foliage are at their best."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular scenic spot near Pune known for its calm reservoir and surrounding hills. Travelers with a Force Urbania on rent can drive to the dam, enjoy lake views, have a picnic with family or friends, and capture memorable photographs. The spacious SUV ensures a comfortable ride for groups and longer journeys."
  }
],



services: [
{
name: "Pune to Shirdi Force Urbania on Rent",
description: "Pune to Shirdi Force Urbania on rent offers a premium and comfortable travel experience for pilgrimage trips with large groups and families. The Force Urbania comes with luxury seating, high roof design, ample legroom, and spacious luggage capacity, making long-distance journeys relaxing and enjoyable. Professional drivers ensure safe and smooth travel via well-planned routes. This service is ideal for temple visits, group tours, and family outings to Shirdi. Air-conditioned interiors and pushback seats enhance travel comfort. With easy booking and transparent pricing, this service ensures a hassle-free spiritual journey."
},
{
name: "Pune to Ashtavinayak Urbania Tour Package",
description: "Pune to Ashtavinayak Urbania tour package offers a complete travel solution for visiting all eight Ganpati temples comfortably. The Urbania provides spacious seating and smooth highway performance, making it ideal for multi-day religious tours. Professional drivers are experienced with temple routes ensuring safe and timely travel. This package is perfect for group pilgrimages and family trips with comfortable travel arrangements."
},
{
name: "Pune to Mahabaleshwar Urbania on Rent",
description: "Pune to Mahabaleshwar Urbania rental provides a luxurious hill-station travel experience with comfortable seating and smooth ride through scenic ghat roads. The vehicle is ideal for group tours, corporate outings, and family vacations with spacious interiors and luggage capacity."
},
{
name: "Force Urbania Vans on Rent in Viman Nagar",
description: "Force Urbania vans on rent in Viman Nagar offer premium travel options for residents and corporate clients. With easy pickup and comfortable seating, this service is ideal for airport transfers, business travel, and group outings."
},
{
name: "Urbania On Rent in Pune",
description: "Urbania on rent in Pune provides luxury group travel with spacious interiors, pushback seats, and air-conditioned comfort. It is ideal for outstation trips, corporate travel, weddings, and tours."
},
{
name: "Bus Hire for Wedding in Pune",
description: "Bus hire for wedding in Pune with Force Urbania ensures comfortable and stylish group transportation for guests. This service is perfect for wedding events, family functions, and large gatherings."
},
{
name: "Force Urbania on Rent in Pune for Corporate Events",
description: "Force Urbania on rent in Pune for corporate events offers premium travel for employee transport, meetings, and conferences. Spacious seating and comfortable interiors ensure professional and smooth travel."
},
{
name: "Force Urbania On Rent in Kothrud",
description: "Force Urbania on rent in Kothrud provides convenient and reliable group travel for local and outstation trips with comfortable seating and professional drivers."
},
{
name: "Force Urbania for Rent in Pune",
description: "Force Urbania for rent in Pune offers flexible travel options for group tours, family trips, and corporate travel with luxury comfort and safety."
},
{
name: "Force Urbania Per Km Rate",
description: "Force Urbania per km rate in Pune provides transparent pricing based on distance and travel duration. Customers can plan their travel budget effectively with clear fare details."
},
{
name: "Force Urbania Luxury Mini Bus on Rent",
description: "Force Urbania luxury mini bus on rent offers premium travel experience with high-end features, spacious seating, and comfortable interiors ideal for long journeys."
},
{
name: "Urbania On Rent in Viman Nagar",
description: "Urbania on rent in Viman Nagar provides convenient access to luxury group travel with easy booking and reliable service."
},
{
name: "Urbania On Rent in Koregaon Park Pune",
description: "Urbania on rent in Koregaon Park Pune offers premium travel for residents and corporate clients with comfortable and spacious vehicles."
},
{
name: "Urbania On Rent in Kharadi",
description: "Urbania on rent in Kharadi provides reliable group transportation for IT professionals and residents with flexible pickup options."
},
{
name: "Urbania On Rent in Hadapsar",
description: "Urbania on rent in Hadapsar offers comfortable travel for families and corporate groups with professional drivers and well-maintained vehicles."
},
{
name: "Force Urbania On Rent in Kalyani Nagar",
description: "Force Urbania on rent in Kalyani Nagar provides premium group travel for business and personal trips with comfortable seating and smooth travel."
},
{
name: "Urbania On Rent for Pune Darshan",
description: "Urbania on rent for Pune darshan offers comfortable city tours covering major attractions with spacious seating and convenient travel for groups."
},
{
name: "Force Urbania Rental Pune",
description: "Force Urbania rental Pune provides luxury travel options for outstation and local trips with reliable vehicles and experienced drivers."
},
{
name: "Force Urbania Cab in Pune",
description: "Force Urbania cab in Pune offers dependable group transportation with spacious interiors and premium comfort for all travel needs."
},
{
name: "Luxury Force Urbania on Rent Pune",
description: "Luxury Force Urbania on rent Pune ensures high-end travel experience with modern features, comfortable seating, and smooth performance."
},
{
name: "Force Urbania Tempo Traveller Pune",
description: "Force Urbania tempo traveller Pune offers advanced group travel with enhanced comfort compared to traditional tempo travellers."
},
{
name: "Book Force Urbania Pune",
description: "Book Force Urbania Pune easily through online platforms with instant confirmation and transparent pricing for hassle-free travel."
},
{
name: "Force Urbania Van Rental Pune",
description: "Force Urbania van rental Pune provides reliable and comfortable travel for large groups with spacious seating and professional drivers."
}
],

tableData: [
["Pune to Shirdi Force Urbania on Rent","Pune to Ashtavinayak Urbania Tour Package"],
["Pune to Mahabaleshwar Urbania on Rent","Force Urbania Vans on Rent in Viman Nagar"],
["Urbania On Rent in Pune","Bus Hire for Wedding in Pune"],
["Force Urbania on Rent in Pune for Corporate Events","Force Urbania On Rent in Kothrud"],
["Force Urbania for Rent in Pune","Force Urbania Per Km Rate"],
["Force Urbania Luxury Mini Bus on Rent","Urbania On Rent in Viman Nagar"],
["Urbania On Rent in Koregaon Park Pune","Urbania On Rent in Kharadi"],
["Urbania On Rent in Hadapsar","Force Urbania On Rent in Kalyani Nagar"],
["Urbania On Rent for Pune Darshan","Force Urbania Rental Pune"],
["Force Urbania Cab in Pune","Luxury Force Urbania on Rent Pune"],
["Force Urbania Tempo Traveller Pune","Book Force Urbania Pune"],
["Force Urbania Van Rental Pune","Urbania On Rent in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Luxury Group Travel Experience",
    WhyChoosedescription: "Velocity Cabs offers Force Urbania on rent in Pune with premium interiors, spacious seating, and superior comfort, making it ideal for group tours, corporate travel, weddings, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our drivers are highly experienced in Pune city routes and highways, ensuring safe driving, smooth journeys, and timely pickups for all group travel needs."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Force Urbania rental in Pune. Customers receive clear fare details including per km charges, tolls, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Urbania Rental Availability",
    WhyChoosedescription: "Our Force Urbania rental service operates 24/7, allowing customers to book vehicles anytime for airport transfers, outstation trips, or special events."
  },
  {
    WhyChooseheading: "Spacious & Fully AC Vehicles",
    WhyChoosedescription: "All Force Urbania vehicles come with powerful air-conditioning, pushback seats, ample legroom, and large luggage space to ensure maximum comfort for every passenger."
  },
  {
    WhyChooseheading: "Multiple Seating Options",
    WhyChoosedescription: "Velocity Cabs offers different seating options including 10-seater, 13-seater, 15-seater, and 17-seater Force Urbania vehicles suitable for small to large groups." 
  },
  {
    WhyChooseheading: "Perfect for Group & Corporate Travel",
    WhyChoosedescription: "Force Urbania is ideal for family tours, corporate outings, school trips, weddings, and pilgrimage travel, offering luxury and convenience in one vehicle."
  },
  {
    WhyChooseheading: "Trusted Urbania Rental in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Force Urbania on rent in Pune due to professional drivers, well-maintained vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Force Urbania on rent in Pune?", answer: "Yes, Velocity Cabs provides Force Urbania rental services in Pune for local and outstation group travel." },
  { question: "What is the price of Force Urbania on rent in Pune?", answer: "Force Urbania rental usually starts from around ₹30 to ₹40 per km depending on seating capacity and trip type." },
  { question: "How many passengers can travel in Force Urbania?", answer: "Force Urbania is available in multiple seating options ranging from 10-seater to 17-seater suitable for group travel." },
  { question: "Is Force Urbania available for outstation trips?", answer: "Yes, Force Urbania is ideal for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Can I book Urbania for weddings or events?", answer: "Yes, Force Urbania is perfect for weddings, corporate events, and group outings with comfortable seating and premium features." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Force Urbania rental service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned with individual vents for passenger comfort." },
  { question: "Can I book Force Urbania online?", answer: "Yes, customers can easily book Force Urbania on rent in Pune online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all bookings include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Kulkarni",
    feedback:
      "Our group trip in a Force Urbania from Pune was very comfortable and well-organized. The vehicle was spacious, clean, and perfect for long-distance travel with family.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Deshmukh",
    feedback:
      "The Force Urbania rental experience in Pune was excellent for our outing. Seating comfort was premium, the van was well-maintained, and the journey felt smooth throughout.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const puneUrbaniaJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Force Urbania On Rent in Pune | Velocity Cabs",
  "description": "Hire Force Urbania vans in Pune for outstation trips, tours, corporate events, weddings, and luxury mini-bus services. Available for Pune to Shirdi, Ashtavinayak, Mahabaleshwar, and city tours in Viman Nagar, Kothrud, Koregaon Park, Kharadi, and Hadapsar.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Force Urbania On Rent Pune",
    "Pune to Shirdi Urbania",
    "Pune to Ashtavinayak Urbania Tour",
    "Pune to Mahabaleshwar Urbania",
    "Urbania Vans Viman Nagar Pune",
    "Urbania Vans Kothrud Pune",
    "Urbania Vans Koregaon Park Pune",
    "Urbania Vans Kharadi Pune",
    "Urbania Vans Hadapsar Pune",
    "Corporate Urbania Hire Pune",
    "Wedding Bus Hire Pune",
    "Luxury Mini Bus on Rent Pune"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Force Urbania On Rent in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Hire Force Urbania vans in Pune for outstation trips, tours, corporate events, weddings, and luxury mini-bus services. Available for Pune to Shirdi, Ashtavinayak, Mahabaleshwar, and city tours in Viman Nagar, Kothrud, Koregaon Park, Kharadi, and Hadapsar."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneUrbaniaJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbaniaonrentinpune;